API_URL = if process.env.NODE_ENV == 'production' then '/api/' else 'http://192.168.1.68:3000/api/'

global.HM_API =
  api_url: API_URL
  config:
    contentType: 'application/json'
    dataType: 'json'
    headers:
      'hm-source': 'HM3'
      'user-email': null
      'user-token': null

sendRequest = (opts) ->
  opts.data = JSON.stringify(_.fromPairs(_.toPairs(opts.data))) if opts.data
  promise = $.ajax(_.merge(opts, HM_API.config))
  promise.then (res = {}) ->
    if res.data && res.data.checkpoints
      if HM.store.state.user.userdata.cache_key == res.data.checkpoints.old_cache_key
        HM.store.state.user.userdata.cache_key = res.data.checkpoints.current_cache_key
    if res.status == 'not_allowed'
      f = ->
        msg = 'Доступ к ХаниМани закончился' if HM.is_russian
        msg = 'You have read-only access to HoneyMoney now' if HM.is_english
        Vue.prototype.$message
          type: 'error'
          message: msg
          duration: 5000
          showClose: true
      setTimeout f, 200
  return promise

setLocalStorage = (status, remember_me, user) ->
  if status == 'success' and remember_me == true
    localStorage.setItem 'email', user.email
    localStorage.setItem 'authentication_token', user.authentication_token
  else
    localStorage.clear()

HM_API.login_user = (data) ->
  promise = new Promise (resolve, reject) ->
    data.from = 'hm3'
    jqXHR = $.post API_URL + 'user_session.json', data
    jqXHR.fail (response) -> reject('network_error')
    jqXHR.done (response) =>
      resolve(response) if response.status == 'success'
      reject('user_not_found') if response.status == 'failure'
      setLocalStorage(response.status, data.remember_me, response.user)

HM_API.load_transactions = (opts) ->
  sendRequest
    url: API_URL + 'transaction/all.json'

HM_API.load_transactions_json = (opts) ->
  sendRequest
    url: API_URL + 'transaction/all_json.json'

HM_API.heartbeat = (checkpoint) ->
  sendRequest
    url:  API_URL + 'test_hm_io/checkpoint'
    type: 'POST'
    data: { checkpoint: checkpoint }

HM_API.save_transaction = (transaction, generator) ->
  data = { transaction: transaction }
  if generator
    data.future_deleted_transactions_ids = generator.future_deleted_transactions_ids
    data.future_common_transactions      = generator.future_common_transactions
  sendRequest
    url:  API_URL + 'transaction'
    type: 'POST'
    data: data

HM_API.destroy_transaction = (params) ->
  sendRequest
    url:  API_URL + "transaction/#{params.id}"
    type: 'DELETE'
    data:
      id: params.id
      future_trs_ids: params.future_trs_ids

HM_API.bulk_update_transactions = (params) ->
  sendRequest
    url:  API_URL + "transaction/bulk_update_transactions"
    type: 'POST'
    data:
      transaction_ids: params.transaction_ids
      new_category: params.new_category

HM_API.import_transactions = (params) ->
  sendRequest
    url:  API_URL + "transaction/bulk_create_transactions"
    type: 'POST'
    data:
      transactions: params.transactions

HM_API.bulk_destroy_transactions = (params) ->
  sendRequest
    url:  API_URL + "transaction/bulk_destroy_transactions"
    type: 'POST'
    data:
      transaction_ids: params.transaction_ids

HM_API.download_transactions = (args) ->
  sendRequest
    url:  API_URL + "transaction/download"
    type: 'POST'
    data: args

HM_API.save_account_virtual = (type, record) ->
  record = _.omit(record, 'user')
  sendRequest
    url:  API_URL + type
    type: 'POST'
    data: record

HM_API.destroy_account_virtual = (type, record) ->
  sendRequest
    url:  API_URL + "#{type}/#{record.id}"
    type: 'DELETE'

HM_API.sort_accounts = (category_id, account_ids) ->
  sendRequest
    url: API_URL + 'account/sort'
    type: 'POST'
    data:
      category_id: category_id
      account_ids: account_ids

HM_API.sort_virtuals = (virtual_ids) ->
  sendRequest
    url: API_URL + 'virtual/sort'
    type: 'POST'
    data:
      virtual_ids: virtual_ids

HM_API.update_user = (changes_hash, passwords) ->
  sendRequest
    url: API_URL + 'user/update'
    type: 'PUT'
    data:
      user: changes_hash
      passwords: passwords

HM_API.create_payment = (months, stripeToken) ->
  sendRequest
    url: API_URL + 'user/create_payment'
    type: 'POST'
    data:
      months: months
      stripeToken: stripeToken

HM_API.create_subscription = (plan, stripeToken) ->
  sendRequest
    url: API_URL + 'user/create_subscription'
    type: 'POST'
    data:
      plan: plan
      stripeToken: stripeToken

HM_API.stripe_info = ->
  sendRequest
    url: API_URL + 'user/stripe_info'
    type: 'GET'

HM_API.update_card = (stripeToken) ->
  sendRequest
    url: API_URL + 'user/update_card'
    type: 'POST'
    data: { stripeToken: stripeToken }

HM_API.reset_user = -> sendRequest { url: API_URL + 'user/reset', type: 'POST' }
HM_API.destroy_user = -> sendRequest { url: API_URL + 'user/destroy', type: 'POST' }

HM_API.create_user = (userdata) ->
  sendRequest
    url: API_URL + 'user/create'
    type: 'POST'
    data:
      userdata: userdata

HM_API.load_currencies = ->
  sendRequest { url: API_URL + 'currencies' }


HM_API.referrals_info = ->
  sendRequest
    url: API_URL + 'user/referrals_info'
    type: 'GET'

module.exports = HM_API
